import React from "react";
import { Form } from "react-bootstrap";

const SelectInput = ({ formik, field, options, disabled }) => (
  <>
    <Form.Control
      as="select"
      id={field}
      name={field}
      disabled={formik.isSubmitting || disabled}
      value={formik.values[field]}
      onChange={formik.handleChange}
      isInvalid={formik.touched[field] && formik.errors[field]}
    >
      {(options || []).map((item) => (
        <option key={item.key || item.value} value={item.value}>
          {item.text}
        </option>
      ))}
    </Form.Control>
    {formik.touched[field] && formik.errors[field] && (
      <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
    )}
  </>
);

export default SelectInput;
